import React, { Fragment, useEffect, useState } from "react";
import { useFetchCompanyCommonDataQuery } from "../../utils/company/companySelector";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import useCustomerFormValidation from "../../hooks/ErrorHandling/useCustomerFormValidation";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { useParams } from "react-router-dom";
import { ReactComponent as mapicon } from "../../assets/images/icons/mapicon.svg";
import { ReactComponent as CircleDeleteIcon } from "../../assets/images/icons/CircleDeleteIcon.svg";

const validationRules = {
  address_type: {
    required: true,
    errorMessage: "Address Type is required",
  },
  point_of_contact: {
    required: true,
    errorMessage: "Point of Contact is required",
  },
  address: {
    required: true,
    errorMessage: "Address is required",
  },
  country_id: {
    required: true,
    errorMessage: "Country is required",
  },
  primary_email: [
    {
      required: true,
      errorMessage: "Email is required.",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
  phone1: [
    {
      required: true,
      errorMessage: "Phone is required",
    },
    {
      number: true,
      errorMessage: "Phone Number required.",
    },
    {
      maxDigits: 15,
      errorMessage: "Must be between 1 to 15 digits.",
    },
  ],
};

const CustomerAddressModel = ({
  onClose,
  AddressData,
  isEditMode,
  setIsEditMode,
  addCustomerId,
  CustomerAddressData,
  onSave,
  handleDelete,
  isAddMode,
  setIsAddMode,
  setRefetchAllData,
  EmptyMessage,
  handleCancel,
}) => {
  const { token } = useRequireAuth();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [editedData, setEditedData] = useState();
  const [editedId, setEditedId] = useState();
  const [customer, setCustomer] = useState([]);
  const { id } = useParams();
  const customerId = parseInt(id);

  const [formData, setFormData] = useState({
    address_type: "",
    point_of_contact: "",
    address: "",
    country_id: "",
    primary_email: "",
    secondry_email: "",
    phone1: "",
  });

  // useEffect(() => {
  //   if (customerId) {
  //     setRefetch((prev) => !prev);
  //   }
  // }, [customerId]);

  const dispatch = useDispatch();
  const { errorMessage, validateForm } = useCustomerFormValidation();

  const handleEditClick = (index, data) => {
    setFormData([data]);
    setIsEditMode(true);
    setEditedId(data?.address?.id);

    setFormData({
      id: data?.address?.id,
      address_type: data?.address_type?.value,
      point_of_contact: data?.point_of_contact?.value,
      address: data?.address?.value,
      city: data?.city?.value,
      state: data?.state?.value,
      zip_code: data?.zip_code?.value,
      country_id: data?.country_id?.value,
      phone1: data?.phone1?.value,
      phone2: data?.phone2?.value,
      primary_email: data?.primary_email?.value,
      secondry_email: data?.secondry_email?.value,
    });
  };

  useEffect(() => {
    if (isAddMode) {
      setFormData({
        id: "",
        address_type: "",
        point_of_contact: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        country_id: "",
        phone1: "",
        phone2: "",
        primary_email: "",
        secondry_email: "",
      });
    }
  }, [isAddMode]);

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleFieldChange = (e) => {
    handleChange(e);
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async (event) => {
    event.preventDefault();

    const formValid = isFormValid();

    if (!formValid) {
      return;
    }

    const Addresses = {
      ...formData,
      customer_id: addCustomerId,
      recordType: "address",
      id: formData.id ? formData.id : "",
    };
    onSave(Addresses);
    setRefetchAllData((prev) => !prev);
  };

  const handleDeleteAddress = async (data) => {
    const payload = {
      recordType: "address",
      cid: addCustomerId ? addCustomerId : customerId,
      rid: data?.address?.id,
    };
    handleDelete(payload, data?.address?.value);
    setRefetchAllData((prev) => !prev);
  };

  const { data: companyCommnData, error, isLoading } = useFetchCompanyCommonDataQuery(token);

  function convertToLower(str) {
    if (typeof str === "string") {
      return str?.toLowerCase();
    }
    return "";
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    // Clean up the event listener
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // const handleCancelClick = () => {
  //   setIsEditMode(false);
  // };

  function convertAddressData(data) {
    return data.map((item) => {
      return {
        customer_id: { value: item.customer_id, field_name: "customer_id", id: item.customer_id },
        address_type: { value: item.address_type, field_name: "address_type", id: item.id },
        point_of_contact: { value: item.point_of_contact, field_name: "point_of_contact", id: item.id },
        address: { value: item.address, field_name: "address", id: item.id },
        city: { value: item.city, field_name: "city", id: item.id },
        state: { value: item.state, field_name: "state", id: item.id },
        zip_code: { value: item.zip_code, field_name: "zip_code", id: item.id },
        country_id: { value: item.country_id, field_name: "country_id", id: item.id },
        phone1: { value: item.phone1, field_name: "phone1", id: item.id },
        phone2: { value: item.phone2, field_name: "phone2", id: item.id },
        primary_email: { value: item.primary_email, field_name: "primary_email", id: item.id },
        secondry_email: { value: item.secondry_email, field_name: "secondry_email", id: item.id },
      };
    });
  }

  useEffect(() => {
    if (true) {
      setCustomer(convertAddressData(CustomerAddressData || []));
    }
  }, [CustomerAddressData]);

  return (
    <div className="relative bg-white h-full w-full font-popns flex flex-col space-y-3">
      {isEditMode ? (
        <>
          {/* <h2 class=" text-1D4469 text-16 font-500 pt-2 px-3">
            {isAddMode ? (
              "Add Address"
            ) : isEditMode ? (
              "Update Address"
            ) : (
              <div className="text-434852 text-16 font-500">View Address</div>
            )}
          </h2> */}
          <form onSubmit={handleSave} className="flex flex-col justify-between pb-5 gap-5 grow min-h-0 mt-3">
            <div className="space-y-3 overflow-y-auto thinscrollbar pr-2 pb-2 px-3">
              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`address_type`}>
                  Address Type <span className="text-red-700">*</span>
                  {errors && <span className="text-red-700">{errors?.address_type}</span>}
                </label>
                <select
                  className="form-select bg-white rounded py-0 border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  text-434852 text-12 font-400 block w-full"
                  id={`address_type`}
                  name="address_type"
                  onChange={handleFieldChange}
                  value={formData?.address_type}
                >
                  <option hidden selected>
                    Select Address Type
                  </option>
                  {(AddressData?.length === 0 || convertToLower(formData?.address_type) === "default") && (
                    <option value="Default" selected={convertToLower(formData?.address_type) === "default"}>
                      Default
                    </option>
                  )}
                  <option value="Primary" selected={convertToLower(formData?.address_type) === "primary"}>
                    Primary
                  </option>
                  <option value="Legal Address" selected={convertToLower(formData?.address_type) === "legal address"}>
                    Legal Address
                  </option>
                </select>
              </div>

              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`address`}>
                  Address <span className="text-red-700">*</span>
                  {errors && <span className="text-red-700">{errors.address}</span>}
                </label>
                <input
                  style={{ height: "30px" }}
                  className="resize-y text-12 font-400 w-full text-434852  bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  block px-3"
                  id={`address`}
                  name="address"
                  placeholder="Enter Address"
                  onChange={handleFieldChange}
                  value={formData?.address}
                ></input>
              </div>
              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`city`}>
                  City
                </label>
                <input
                  className="rounded border-DFE2E5 block w-full text-434852 border text-12 font-400 bg-white  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 px-3"
                  type="text"
                  id={`city`}
                  name="city"
                  placeholder="Enter City"
                  onChange={handleFieldChange}
                  value={formData?.city}
                />
              </div>
              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`state`}>
                  State
                </label>
                <input
                  className=" block w-full px-3 text-434852 border rounded border-DFE2E5 text-12 font-400 bg-white  focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  "
                  type="text"
                  id={`state`}
                  name="state"
                  placeholder="Select"
                  onChange={handleFieldChange}
                  value={formData?.state}
                />
              </div>

              <div>
                <label htmlFor={`country_id`} className={`block  text-434852 text-14 font-400`}>
                  Country <span className="text-red-700">*</span>
                  {errors && <span className="text-red-700">{errors.country_id}</span>}
                </label>
                <select
                  id={`country_id`}
                  name="country_id"
                  placeholder="Select"
                  onChange={handleFieldChange}
                  className="form-select block appearance-none w-full text-12 font-400 text-434852  px-3 leading-tight focus:outline-none focus:bg-white  bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 "
                >
                  <option selected hidden>
                    Select Country
                  </option>
                  {companyCommnData?.data?.country?.map((CountryData) => (
                    <option
                      key={CountryData.id}
                      value={CountryData.country_name}
                      selected={formData?.country_id === CountryData.country_name}
                    >
                      {CountryData.country_name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`zip_code`}>
                  Zip Code
                </label>
                <input
                  className=" px-3 text-434852 text-12 font-400 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full
"
                  id={`zip_code`}
                  type="text"
                  name="zip_code"
                  placeholder="Enter Zip code"
                  onChange={handleFieldChange}
                  value={formData?.zip_code}
                />
              </div>

              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`point_of_contact`}>
                  Point of Contact <span className="text-red-700">*</span>
                  {errors && <span className="text-red-700">{errors.point_of_contact}</span>}
                </label>
                <input
                  className="px-3 text-434852 text-12 font-400 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full"
                  type="text"
                  id={`point_of_contact`}
                  name="point_of_contact"
                  placeholder="Enter Point of Contact"
                  onChange={handleFieldChange}
                  onBlur={handleBlur}
                  value={formData?.point_of_contact}
                />
              </div>

              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`primary_email`}>
                  Primary Email <span className="text-red-700">*</span>
                  {errors && <span className="text-red-700">{errors.primary_email}</span>}
                </label>

                <input
                  className=" px-3 text-434852 text-12 font-400 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full"
                  id={`primary_email`}
                  type="text"
                  name="primary_email"
                  placeholder="Enter Email"
                  onChange={handleFieldChange}
                  value={formData?.primary_email}
                />
              </div>
              <div>
                <label className="block font-400 text-434852 text-14 " htmlFor={`secondry_email`}>
                  Secondary Email
                  {errors && <span className="text-red-700 ms-1">{errors.secondry_email}</span>}
                </label>
                <input
                  className="px-3 text-434852 text-12 font-400 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full"
                  id={`secondry_email`}
                  type="text"
                  placeholder="Enter Phone Number"
                  name="secondry_email"
                  value={formData?.secondry_email}
                  onChange={handleFieldChange}
                />
              </div>

              <div>
                <label className="block font-400 text-434852 text-14" htmlFor={`phone1`}>
                  Phone 1<span className="text-red-700">*</span>
                  {errors && <span className="text-red-700 ms-1">{errors.phone1}</span>}
                </label>
                <input
                  className="px-3 text-12 font-400 text-434852 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  block w-full"
                  type="text"
                  name="phone1"
                  id={`phone1`}
                  placeholder="Enter Phone Number"
                  onChange={handleFieldChange}
                  value={formData?.phone1}
                  // onKeyDown={(e) => {
                  //   if (
                  //     !/^\d+$/.test(e.key) &&
                  //     !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                />
              </div>
              <div>
                <label className="block font-400 text-434852 text-14" htmlFor={`phone2`}>
                  Phone 2
                </label>
                <input
                  className="px-3 text-434852 text-12 font-400 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 block w-full"
                  type="text"
                  id={`phone2`}
                  name="phone2"
                  placeholder="Enter Phone Number"
                  onChange={handleFieldChange}
                  value={formData?.phone2}
                  // onKeyDown={(e) => {
                  //   if (
                  //     !/^\d+$/.test(e.key) &&
                  //     !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)
                  //   ) {
                  //     e.preventDefault();
                  //   }
                  // }}
                />
              </div>
            </div>

            <div className="flex justify-end text-md w-full border-t border-BECBD3 pt-3 px-3">
              <div className="">
                <button
                  onClick={handleCancel}
                  type="button"
                  className="px-6 py-1 text-16  rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2"
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  className={`px-6 py-1 text-16 rounded-5px font-500 bg-primary hover:bg-primary-hover text-white focus:outline-none cbtn-transition-bg`}
                >
                  {editedData?.address?.id ? "Update" : "SAVE"}
                </button>
              </div>
            </div>
          </form>
        </>
      ) : (
        <div
          className={`grow min-h-0 pb-10 overflow-y-auto  thinscrollbar pr-2 px-3 mt-4 ${customer.length > 0 ? "" : "items-center"} `}
        >
          {/* <h3 className="py-2 px-3 text-434852 text-16 font-500 my-2">View Address</h3> */}
          {/* <div className="py-3 px-4 border rounded-tl-lg rounded-tr-lg border-[#D2DAE1] font-500">Address List</div> */}
          {customer.length ? (
            customer?.map((data, index) => (
              <>
                <div key={index} className="border-b border-l border-r ">
                  <div
                    className="relative transition-all duration-300"
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <div className={`px-4 py-3 ${hoveredIndex === index ? "bg-[#F1F6F9]" : "bg-white"}`}>
                      <div className="text-lg">{data?.point_of_contact?.value}</div>
                      <div className="relative text-[#666]">
                        <p>{data?.address?.value}</p>
                        <p>
                          {data?.city?.value}, {data?.state?.value}-{data?.zip_code?.value}, {data?.country?.value}
                        </p>
                        <p>{data?.phone1?.value}</p>
                        <p>{data?.primary_email?.value}</p>

                        <div
                          className={`absolute bottom-0 right-0 flex justify-end me-5 gap-3 transition-opacity duration-300 opacity-0 ${
                            hoveredIndex === index ? "opacity-100" : ""
                          } h-[30px] items-center`}
                        >
                          <button onClick={() => handleEditClick(index, data)}>
                            <i className="bi bi-pencil text-[#969BA9] font-500"></i>
                          </button>
                          <button onClick={() => handleDeleteAddress(data)}>
                            {/* <i className="bi bi-trash-fill text-[#F84545] font-500"></i> */}
                            <CircleDeleteIcon />
                          </button>
                        </div>
                      </div>

                      {/* <div className="flex gap-4">
                        {[
                          { label: "Address Type", value: data?.address_type?.value },
                          { label: "Point of Contact", value: data?.point_of_contact?.value },
                        ].map((item, i) => (
                          <div key={i} className="w-1/2 min-w-24 flex flex-col pt-3">
                            <label className="text-14 font-300 text-[#848687]">{item.label}</label>
                            <span className="text-14 text-[#2C495D] font-400 break-all">{item.value || "--"}</span>
                          </div>
                        ))}
                      </div> */}

                      {/* <div className="flex flex-col mt-2">
                        <label className="text-14 font-300 text-[#848687]">Address</label>
                        <span className="break-words text-14 text-[#2C495D] font-400 break-all">
                          {data?.address?.value || "--"}
                        </span>
                      </div> */}

                      {/* <div className="flex gap-4 mt-2">
                        {[
                          { label: "City", value: data?.city?.value },
                          { label: "State", value: data?.state?.value },
                          { label: "Zip Code", value: data?.zip_code?.value },
                        ].map((item, i) => (
                          <div key={i} className="w-1/3 min-w-24 flex flex-col">
                            <label className="text-14 font-300 text-[#848687] ">{item.label}</label>
                            <span className="text-14 text-[#2C495D] font-400 break-all">{item.value || "--"}</span>
                          </div>
                        ))}
                      </div> */}

                      {/* <div className="flex gap-4 mt-2">
                        {[
                          { label: "Email", value: data?.primary_email?.value },
                          { label: "Phone No.", value: data?.phone1?.value },
                        ].map((item, i) => (
                          <div key={i} className="w-1/2 flex flex-col">
                            <label className="text-14 font-300 text-[#848687]">{item.label}</label>
                            <span className="text-14 text-[#2C495D] font-400 break-all">{item.value || "--"}</span>
                          </div>
                        ))}
                      </div> */}
                    </div>
                  </div>
                </div>
              </>
            ))
          ) : (
            <>
              <EmptyMessage Icon={mapicon} Message={"No Address is available."} ButtonText={"Add Address"} />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerAddressModel;
